import { css } from 'styled-components';
import theme from './theme';

export default css`
  html,
  body {
    color: ${theme.textColors.baseText};
    background-color: ${theme.commonColors.secondBackground};
  }

  a {
    color: ${theme.textColors.link};
  }

  .dnd-placeholder {
    position: absolute;
    z-index: 10;
    border-left: 2px solid ${theme.commonColors.second};
  }

  .image-drag-enabled {
    .scroll-collection-area {
      display: block;
    }
  }
`;
